import { z } from 'zod';

export const SettingsDtoSchema = z.object({
	key: z.string().describe('Ключ настройки'),
	title: z.string().describe('Название настройки'),
	value: z.string().nullable().describe('Значение настройки'),
});

export type SettingsDto = z.infer<typeof SettingsDtoSchema>;

export const SettingsUpdateDtoSchema = z.object({
	key: z.string().describe('Ключ настройки'),
	value: z.string().nullable().describe('Значение настройки'),
});

export type SettingsUpdateDto = z.infer<typeof SettingsUpdateDtoSchema>;

export const SettingsUpdateAllDtoSchema = z.object({
	settings: z.array(SettingsDtoSchema).describe('Массив настроек'),
});

export type SettingsUpdateAllDto = z.infer<typeof SettingsUpdateAllDtoSchema>;

/**
 * Время смены QR кода
 */
export const KeyQrChange = 'qr_change';

/**
 * Время активности QR кода
 */
export const KeyQrActive = 'qr_active';

/**
 * Время хранения Qr кода
 */
export const KeyQrLive = 'qr_live';

/**
 * Погрешность координат
 */
export const CoordsError = 'coords_error';

/**
 * Запрет отметок из приватного режима браузера (1/0)
 */
export const DeviceBlockIncognito = 'device_block_incognito';
